/* eslint react-hooks/rules-of-hooks: "warn" */
import { getHotkeyMenu, HOTKEY_TYPE, useFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { IExportContextMenuItem, IRenderContextMenuItemArgs } from '../../../type';
import MenuItem from '../../../views/menu-item';

const render = ({ activeLayer, pickLayer }: IRenderContextMenuItemArgs) => {
    const { $t } = getLocaleStore();
    const framework = useFramework();
    const layer = pickLayer || activeLayer;

    if (!layer) return null;

    let disabled = false;
    if (pickLayer) {
        disabled = !framework.checkPossibleDelete(pickLayer);
    }

    const item = {
        disabled,
        name: $t((v) => v.contextMenuLayer.menuConfig.delete),
        type: HOTKEY_TYPE.delete,
        desc: getHotkeyMenu(HOTKEY_TYPE.delete),
        onClick: () => {
            framework.events.emitDelete('context-menu');
        },
    };

    return <MenuItem {...item}></MenuItem>;
};

export default {
    group: 4,
    sort: 3,
    render,
} as IExportContextMenuItem;
